/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_8_HInputs */

const en_privacy_8_h = /** @type {(inputs: Privacy_8_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Security`)
};

const id_privacy_8_h = /** @type {(inputs: Privacy_8_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keamanan`)
};

/**
* | output |
* | --- |
* | "Security" |
*
* @param {Privacy_8_HInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const privacy_8_h = /** @type {((inputs?: Privacy_8_HInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_8_HInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_privacy_8_h(inputs)
	return en_privacy_8_h(inputs)
});